// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2NmJK","content":"RecentSearches_content__17XWN"};